<script>
    import CRUD from './CRUD.svelte';
    import { fetchVendedores, saveVendedor, removeVendedor, searchVendedores, subscribeToVendedores, unsubscribeFromVendedores, fetchAtributosVendedor } from '../controllers/vendedorController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js'; // Función para cargar las sucursales
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
  
    let vendedorColumns = [
      { label: 'Sucursal', field: 'sucursal_descrip', type: 'text'  },
      { label: 'Codigo', field: 'codigo', type: 'text'  },
      { label: $t('fields.name'), field: 'nombre', type: 'text'  },
      { label: 'Email', field: 'email', type: 'text'  },
      { label: $t('fields.state'), field: 'sta', type: 'bool'  },
    ];
  
    let newVendedor = {
      sucursal: '',
      nombre: '',
      email: '',
      sta: true,
      atributos: [], // Atributos adicionales
    };

    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: 'Código', key: 'codigo', type: 'text', required: true },
        { label: $t('fields.name'), key: 'nombre', type: 'text', required: true },
        { label: 'Email', key: 'email', type: 'text', required: true },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox' }
    ]; 

    // Opciones de sucursales
    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
  </script>
  
  <CRUD 
    title={$t('entities.vendedores')}
    entityName="vendedor"
    newEntity={newVendedor}
    columns={vendedorColumns}
    fetchEntities={fetchVendedores}
    saveEntity={saveVendedor}
    removeEntity={removeVendedor}
    searchEntities={searchVendedores}
    subscribeToChanges={subscribeToVendedores}
    unsubscribeFromChanges={unsubscribeFromVendedores}
    editColumns={editColumns}
    fetchAtributos={fetchAtributosVendedor}
  />
  